import { FC } from 'react'

import {
  Select as PrimarySelect,
  SelectProps as PrimarySelectProps,
} from '@mantine/core'
import styled from 'styled-components'

import { colors } from 'src/Helpers/constants'

export type SelectProps = PrimarySelectProps

const StyledSelect = styled(PrimarySelect)`
  position: relative;
  width: 100%;

  input {
    height: 41px;
    border: 1px solid ${colors.secondGray};
    color: ${colors.thirdBlue};
    --input-placeholder-color: ${colors.thirdBlue};

    &::placeholder {
      opacity: 0.5;
      font-size: 12px;
    }
  }

  label {
    position: absolute;
    top: -7px;
    left: 10px;
    z-index: 1;
    width: fit-content;
    background-color: white;
    padding: 0 5px;
    font-size: 10px;
    color: ${colors.thirdGray};
  }

  /* Style for the add client option */
  [data-combobox-option][data-value='add_client'] {
    color: ${colors.mainBlue} !important;
    font-weight: 600;

    &:hover {
      background-color: ${colors.mainBlue} !important;
      color: white !important;
    }
  }

  &[data-error] input {
    border-color: ${colors.red};
  }

  &[data-error] {
    .mantine-Select-wrapper {
      margin-bottom: 0px !important;
    }
  }

  .mantine-Select-error {
    position: absolute;
    bottom: -15px;
    font-size: 11px;
    text-align: left;
  }
`

export const Select: FC<SelectProps> = (props) => {
  return <StyledSelect {...props} />
}
